<template>
  <div class="product-description-text">
    <h2 class="product-description-text__headline">
      <span>{{ description1 }}</span>
      <span v-if="description2">{{ description2 }}</span>
      <span v-if="description3">{{ description3 }}</span>
      <span v-if="showShortDescription && shortDescription && !description3">{{ shortDescription }}</span>
    </h2>
    <read-more
      text-more="ads.main.detail.read_more"
      text-less="ads.main.detail.read_less"
      :max-height="140"
    >
      <div
        class="product-description-text__description"
        v-html="longDescription"
      />
    </read-more>
  </div>
</template>

<script lang="ts">
  import {Vue, Options, Prop} from 'vue-property-decorator';
  import productStore, {ProductStore} from '../../stores/product/ProductStore';
  import ReadMore from '../readMore/readMore.vue';
  import type ProductDetails from '../../types/ProductDetails';

  @Options({
    name: 'product-description-text',
    components: {ReadMore}
  })
  export default class ProductDescriptionText extends Vue {
    @Prop({default: false})
    showShortDescription: boolean;

    productStore: ProductStore = productStore;

    get productDetails(): ProductDetails {
      return this.productStore.productDetails;
    }

    get longDescription(): string {
      return this.productDetails.description;
    }

    get description1(): string {
      return this.productDetails.product.description1;
    }

    get description2(): string {
      return this.productDetails.product.description2;
    }

    get description3(): string {
      return this.productDetails.product.description3;
    }

    get shortDescription(): string {
      return this.productDetails.product.shortDescription;
    }
  }
</script>
